<script lang="ts">
    import { getDashboardCtx } from "../../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import copy from "copy-to-clipboard";
    import { createProductPaymentLinkSE } from "@/services/referrals";
    import { PRODUCTS } from "../../lib/products";

    const store = getDashboardCtx();

    async function copyProductLink(priceId: string, productId: string) {
        try {
            const { url } = await createProductPaymentLinkSE(
                store.user.firebaseUser,
                priceId,
                store.user.referralCode,
                productId === "kit" ? false : true,
            );
            copy(url);
            store.toast(translate("PARTNER_LINK_COPIED", "Enlace copiado"));
        } catch (err) {
            console.error("❌ createProductPaymentLink error:", err);
        }
    }
</script>

<div class="referrals__products">
    <h3>
        {translate(
            "PARTNER_PRODUCTS_TITLE",
            "Productos para promocionar",
        )}
    </h3>
    <ul>
        {#each PRODUCTS as p}
            <li>
                <div class="prodInfo">
                    <img src={p.image} alt={p.id} />
                    <div class="prodText">
                        <strong>{p.name}</strong>
                        <span class="prodId">{p.id}</span>
                    </div>
                </div>
                <button
                    class="button --secondary"
                    onclick={() =>
                        copyProductLink(p.priceId, p.id)}
                >
                    {translate(
                        "PARTNER_COPY_LINK",
                        "Copiar enlace",
                    )}
                </button>
            </li>
        {/each}
    </ul>
</div>
